import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { AlertifyService } from '../common/services/alertify.service';
import { CustomerVM, OperationResult, CustomerMovementVM, CustomerWithBalanceAndLastPaymentDateVM } from '../models/view-models';
import { map } from 'rxjs/operators';
import { ErrorService } from '../interceptors/error.service';

@Injectable({
  providedIn: 'root'
})
export class CustomersService {

  apiUrl: string = `${environment.apiUrl}/Customer`;

  constructor(private http: HttpClient,
    private error: ErrorService,
    private alertify: AlertifyService) { }

  insert(customer: CustomerVM) {
    return this.http.post(this.apiUrl, customer)
      .pipe(map((response: OperationResult<CustomerVM>) => {
        if (response.Success) {
          this.alertify.success("Se agregó el cliente");
          return response.Data;
        } else {
          this.error.logError(response);
          return null;
        }
      }));
  }

  update(customer: CustomerVM) {
    return this.http.put(this.apiUrl, customer)
      .pipe(map((response: OperationResult<CustomerVM>) => {
        if (response.Success) {
          this.alertify.success("Se editó el cliente");
          return response.Data;
        } else {
          this.error.logError(response);
          return null;
        }
      }));
  }

  delete(uuid: string) {
    const uri = `${this.apiUrl}?uuid=${uuid}`;
    return this.http.delete(uri)
      .pipe(map((response: OperationResult<boolean>) => {
        if (response.Success) {
          this.alertify.success("Se eliminó el cliente");
          return response.Data;
        } else {
          this.error.logError(response);
          return false;
        }
      }));
  }

  getAll() {
    return this.http.get(this.apiUrl)
      .pipe(map((response: OperationResult<CustomerWithBalanceAndLastPaymentDateVM[]>) => {
        if (response.Success) {
          return response.Data;
        } else {
          this.error.logError(response);
          return null;
        }
      }));
  }
  
  getCreditCustomers() {
    const uri = `${this.apiUrl}/GetCreditCustomers`;
    return this.http.get(uri)
      .pipe(map((response: OperationResult<CustomerVM[]>) => {
        if (response.Success) {
          return response.Data;
        } else {
          this.error.logError(response);
          return null;
        }
      }));
  }

  getById(uuid: string) {
    const uri = `${this.apiUrl}/GetByIdentifier?uuid=${uuid}`;
    return this.http.get(uri)
      .pipe(map((response: OperationResult<CustomerVM>) => {
        if (response.Success) {
          return response.Data;
        } else {
          this.error.logError(response);
          return null;
        }
      }));
  }
  
  getCustomerWithBalanceAndLastPaymentDate(uuid: string) {
    const uri = `${this.apiUrl}/GetCustomerWithBalanceAndLastPaymentDate?uuid=${uuid}`;
    return this.http.get(uri)
      .pipe(map((response: OperationResult<CustomerWithBalanceAndLastPaymentDateVM>) => {
        if (response.Success) {
          return response.Data;
        } else {
          this.error.logError(response);
          return null;
        }
      }));
  }

  getByCustomerId(id: number) {
    const uri = `${this.apiUrl}/GetByCustomerId?id=${id}`;
    return this.http.get(uri)
      .pipe(map((response: OperationResult<CustomerVM>) => {
        if (response.Success) {
          return response.Data;
        } else {
          this.error.logError(response);
          return null;
        }
      }));
  }
}
